<mat-card *ngIf="loading">
  <mat-card-header class="d-block col-lg-12" style="padding: 12px 37px;">
    <div class="row p-b-10">Elaborazione dati previsionali in corso...</div>
    <mat-progress-bar class="row" mode="indeterminate"></mat-progress-bar>
  </mat-card-header>
  <mat-card-content>
    <ngx-skeleton-loader count="5"></ngx-skeleton-loader>
  </mat-card-content>
</mat-card>
<mat-card *ngIf="!loading">
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title>Consumo e produzione stimati</mat-card-title>
      <mat-card-subtitle>Prossimi 7 giorni</mat-card-subtitle>
    </mat-card-title-group>
    <div>
    </div>
  </mat-card-header>
  <mat-card-content>
    <apx-chart #chart *ngIf="chartOptions.series && chartOptions.chart" [series]="chartOptions.series"
      [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis ?? {}" [yaxis]="chartOptions.yaxis ?? {}"
      [title]="chartOptions.title ?? {}" [legend]="chartOptions.legend ?? {}"
      [plotOptions]="chartOptions.plotOptions ?? {}" [dataLabels]="chartOptions.dataLabels ?? {}"
      [tooltip]="chartOptions.tooltip ?? {}"></apx-chart>
  </mat-card-content>
</mat-card>